import { useTranslation } from 'react-i18next';

/**
 * Read-only org unit display with "..." button to open the picker.
 * Styled like small-select — no SearchBar containers or max-width constraints.
 */
export default function OrgUnitSearchField({ displayLabel = '', onOpenPicker, className = '' }) {
    const { t } = useTranslation();
    const placeholder = t('users.table.search.options.structuralGroup');

    return (
        <div className={`org-unit-search-field ${className}`.trim()}>
            <input
                type="text"
                className="small-input org-unit-search-field__input"
                readOnly
                placeholder={placeholder}
                value={displayLabel}
                title={displayLabel}
            />
            <button
                type="button"
                className="org-unit-search-field__btn"
                onClick={() => onOpenPicker?.()}
                title={placeholder}
            >
                ...
            </button>
        </div>
    );
}
